import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { KNOWLEDGE_ALERTS_FEATURE_CODE } from '../features/plans/models/entitlement.model';
import { PlanFeatureService } from '../features/plans/services/plan-feature.service';

/**
 * R6 — bloquea la sección lazy /alerts cuando el plan efectivo de la cuenta no tiene la feature
 * `knowledge_alerts`; redirige a /home. Con la feature OFF la sección es indistinguible de
 * inexistente (el módulo ni se carga por canMatch).
 */
@Injectable({ providedIn: 'root' })
export class KnowledgeAlertsFeatureGuard implements CanMatch, CanActivate {
  constructor(
    private readonly planFeatures: PlanFeatureService,
    private readonly router: Router
  ) {}

  private check(): Observable<boolean | UrlTree> {
    return this.planFeatures.hasFeature(KNOWLEDGE_ALERTS_FEATURE_CODE).pipe(
      take(1),
      map((hasFeature) => (hasFeature ? true : this.router.createUrlTree(['/home'])))
    );
  }

  canMatch(): Observable<boolean | UrlTree> {
    return this.check();
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.check();
  }
}
